/** Define some meta info about shop filters so we can parse url params, etc. */

// TODO: update if/when marketplace_filter_update is merged
// AFAIK, there's no great way to combine the next two for more concision
// since js doesn't know anything about ts
export interface ShopFilters {
  min_price?: number;
  max_price?: number;
  status?: 'all' | 'open' | 'resale_only' | 'sold';
}

export const SHOP_FILTERS = {
  min_price: { typeof: 'number', default: 0 },
  max_price: { typeof: 'number', default: 0 },
  status: { typeof: 'string', default: 'open' },
};

export const NON_FILTER_PARAMS = {
  q: { typeof: 'string', default: '' },
  order: { typeof: 'string', default: 'recommended' },
  deviationid: { typeof: 'number', default: null },
};

function pickObjectField<T>(obj, fieldName) {
  const newObject: T = {} as T;
  for (const [name, data] of Object.entries(obj)) {
    newObject[name] = (data as any)[fieldName];
  }
  return newObject;
}

export const SHOP_FILTER_DEFAULTS = pickObjectField<ShopFilters>(
  SHOP_FILTERS,
  'default'
);

export const SHOP_PARAMS_TYPEOFS = {
  ...pickObjectField<Record<string, string>>(SHOP_FILTERS, 'typeof'),
  ...pickObjectField<Record<string, string>>(NON_FILTER_PARAMS, 'typeof'),
};

export enum StripDeviationType {
  UNKNOWN = 'unknown',
  COMMISSION = 'commission',
  TIER = 'tier',
  PCP = 'pcp',
  ADOPTABLE = 'adoptable',
}
